import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({ baseURL: API, timeout: 30000 });

apiClient.interceptors.request.use((config) => {
  console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const apiService = {
  submitInterestForm: async (formData) => {
    try {
      const response = await apiClient.post('/interest-form', formData);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || 'Failed to submit application. Please try again.';
      throw new Error(errorMessage);
    }
  },
  uploadVideo: async (file) => {
    try {
      const formData = new FormData();
      formData.append('video', file);
      const response = await apiClient.post('/upload-video', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || 'Failed to upload video. Please try again.';
      throw new Error(errorMessage);
    }
  },
  submitContractSignature: async (contractData) => {
    try {
      const response = await apiClient.post('/contract-signature', contractData);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || 'Failed to submit contract signature. Please try again.';
      throw new Error(errorMessage);
    }
  },
  getInterestForms: async (limit = 50, skip = 0) => {
    try {
      const response = await apiClient.get('/interest-forms', { params: { limit, skip } });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.detail || 'Failed to retrieve applications.');
    }
  },
  healthCheck: async () => {
    const response = await apiClient.get('/');
    return response.data;
  }
};

export default apiService;